__turbopack_context__.v({
  "btnBotmRightCurve": "YNRJLW_btnBotmRightCurve",
  "btnTopLeftCurve": "YNRJLW_btnTopLeftCurve",
  "btnWrapper": "YNRJLW_btnWrapper",
});
